<template>
  <div class="WithdrawReports">
    <h3 class="mb-3 text-right">Solicitudes de retiro</h3>
    <b-card>
      <b-container fluid>
       
        <b-tabs content-class="mt-3">
          <b-tab title="Solicitudes" active>
              <Request />
          </b-tab>
          <b-tab title="Retiros realizados">
            <Withdraw />
          </b-tab>
        </b-tabs>
      </b-container>
    </b-card>
  </div>
</template>

<script>
import Withdraw from "../components/WithdrawReports/Withdraw";
import Request from "../components/WithdrawReports/Requests";

export default {
    name: 'WithdrawReports',
    components:{
        Withdraw,
        Request
    }
}
</script>

<style>

</style>